module.exports = __webpack_public_path__ + "static/media/education.d52f3ede.png";